import type { LockDetail } from "@pimo/resource-lock-plugin";

type LockDetailsPatch = {
  settingsLock?: LockDetail;
  projectLocks?: Record<
    string,
    { edit: Partial<LockDetail>; update: Partial<LockDetail> }
  >;
  itemLocks?: Record<string, Partial<LockDetail>>;
};

export function patchLockDetails(
  app: { patchAppState: (state: { lockDetails: LockDetailsPatch }) => void },
  lockDetails: LockDetailsPatch
) {
  app.patchAppState({
    lockDetails,
  });
}
